import { FC } from 'react';
import { ICardIconDescriptionColumnsBladeProps } from 'blades/CardIconDescriptionColumnsBlade/@types';
import CardIconDescription from 'components/CardIconDescription';
import Carousel from 'components/Carousel';
import { SliderArrow } from 'components/CarouselWrapper';
import LeftArrowBlue from '../../../public/static/images/homePage/carouselBlade/left_arrow_blue.svg';
import RightArrowBlue from '../../../public/static/images/homePage/carouselBlade/right_arrow_blue.svg';
import SectionWrapper from '../SectionWrapper';
import Typo from '../Typo';
import styles from './cardIconDescriptionColumns.module.sass';
import { useIsMobileViewport } from '../../hooks/useIsMobileViewport';

const CardIconDescriptionColumnsComponent: FC<ICardIconDescriptionColumnsBladeProps> = ({
  title,
  description,
  cards,
  backgroundColor,
}) => {
  const { isMobile } = useIsMobileViewport();

  return (
    <SectionWrapper classes={`has-text-centered ${styles.wrapper} is-bgcolor-${backgroundColor} `}>
      <Typo h2 classes={styles.title}>
        {title}
      </Typo>
      <Typo classes={styles.description}>{description}</Typo>

      {isMobile ? (
        <Carousel
          blurInactive={false}
          slideWidth={390}
          settings={{
            slidesToScroll: 1,
            speed: 500,
            centerMode: true,
            variableWidth: true,
            dots: true,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            nextArrow: (
              <SliderArrow
                type="next"
                alternateArrow={RightArrowBlue}
                onClick={this}
                alternateTheme
                isCentered
              />
            ),
            prevArrow: (
              <SliderArrow
                type="prev"
                alternateArrow={LeftArrowBlue}
                alternateTheme
                onClick={this}
                isCentered
              />
            ),
          }}
        >
          {cards.map(card => (
            <CardIconDescription key={card.sys.id} {...card.fields} />
          ))}
        </Carousel>
      ) : (
        <div className={styles.cardGrid}>
          {cards.map(card => (
            <CardIconDescription key={card.sys.id} {...card.fields} />
          ))}
        </div>
      )}
    </SectionWrapper>
  );
};

export default CardIconDescriptionColumnsComponent;
